import { Avatar, Indicator, Tooltip } from "@mantine/core";
import { NavLink, useLocation } from "react-router";
import styled from "styled-components";
import { useState } from "react";

interface SidebarItemProps {
  navigateTo?: any;
  logoutClick?: any;
  title: string;
  iconSrc?: any;
  isCollapsible?: boolean;
  subItems?: { title: string; navigateTo: string }[];
  sidebarOpen?: boolean;
}

const NavbarItem: React.FC<SidebarItemProps> = ({
  navigateTo,
  title,
  isCollapsible,
  subItems = [],
  iconSrc,
  logoutClick,
  sidebarOpen = true,
}) => {
  const location = useLocation();
  
  const isCurrentPathActive = location.pathname.startsWith(navigateTo);

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e: any) => {
    if (isCollapsible) {
      e.preventDefault();
      setIsOpen((prev) => !prev);
    }
    if (location.pathname === navigateTo) {
      e.preventDefault();
    }
  };


  return (
    <Tooltip label={title} position="right" disabled={sidebarOpen} withArrow>
      <ItemWrapper $isActive={isCurrentPathActive} $sidebarOpen={sidebarOpen}>
        <StyledItemLink onClick={logoutClick ?? handleClick} to={navigateTo}>
          {({ isActive }) => (
            <NavContentWrapper $sidebarOpen={sidebarOpen}>     
              <Indicator color="#F97316" size={10} withBorder disabled position="bottom-start">
                <Avatar
                  src={iconSrc}
                  style={{
                    filter: isActive
                      ? "brightness(0) saturate(100%) invert(16%) sepia(100%) saturate(3046%) hue-rotate(251deg) brightness(108%) contrast(118%)"
                      : "",
                  }}
                  size={20}
                  radius={0}
                />
              </Indicator>
              {sidebarOpen && (
              <span
                style={{
                  fontSize: "16px",
                  color: isActive ? "#5C26FF" : "#4C4C4C",
                }}
              >
                {title}
              </span>
              )}
            </NavContentWrapper>
          )}
        </StyledItemLink>
      
      {isCollapsible && sidebarOpen && isOpen && (
          <SubitemsWrapper>
            {subItems.map((item) => (
              <StyledSubitemLink
                to={`${navigateTo}/${item.navigateTo}`}
                key={item.navigateTo}
              >
                {({ isActive }) => (
                  <span style={{ color: isActive ? "#5C26FF" : "black", fontSize: "14px" }}>
                    {item.title}
                  </span>
                )}
              </StyledSubitemLink>
            ))}
          </SubitemsWrapper>
        )}
      </ItemWrapper>
    </Tooltip>
  );
};

export default NavbarItem;


const StyledItemLink = styled(NavLink)`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: center;
`;
const StyledSubitemLink = styled(NavLink)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: none;
`;

const SubitemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 32px;
  gap: 8px;
  padding-bottom: 8px;
`;


const NavContentWrapper = styled.div<{ $isActive?: boolean; $sidebarOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$sidebarOpen ? "flex-start" : "center")};
  gap: 12px;
  width: 100%;
  height: 44px;
  border-radius: 99px;
  padding: ${(props) => (props.$sidebarOpen ? "12px 16px" : "0px")};
  transition: background-color 0.3s ease;
`;

const ItemWrapper = styled.div<{ $isActive?: boolean; $sidebarOpen?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 99px;
  background-color: ${(props) => (props.$isActive ? "#EEF2FF" : "transparent")};
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #eef2ff;
  }
`;